import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/entorno/entorno-client.tsx");
